import { useEffect } from "react";
import styled from "styled-components";
import appConfig from "../config/appConfig.json";
import collection from "../config/NFTCollection";
import FeaturedImage from "../config/FeaturedImage";
import { getPinataUrl } from "../utils/imgLoader";
import aboutImg from "../assets/image/home/hakkimizda.png";
import roadMapImg from "../assets/image/home/yolHaritasi.png";
import rarityImg from "../assets/image/home/benzersizlik.png";
import creatorImg from "../assets/image/home/yaratici.png";
import yellowSectionImg from "../assets/image/home/sariKisim.png";

// import { imageOnLoadHandler, imageOnErrorHandler } from "../utils/imgLoader";

const ColorNumber = styled.span`
  margin-right: 4px;
  color: #0075eb;
`;

const NFTImage = styled.img`
  width: 100%;
  height: 40vh;
  object-fit: cover;
  @media (max-width: 576px) {
    height: 30vh;
  }
`;

const FeatureImage = styled.img.attrs({
  className: "nft-image",
})`
  width: 280px;
  height: 315px;
  object-fit: cover;
  @media (max-width: 767px) {
    width: 242px;
    height: 265px;
  }
  @media (max-width: 479px) {
    width: 160px;
    height: 210px;
  }
`;

export default function Home() {
  useEffect(() => {
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  });

  const groupCollection = Array.from({ length: Math.ceil(3) }, (_, i) =>
    collection.slice(i * 8, i * 8 + 8)
  );

  const renderGallery = () => {
    const dataWId = [
      "8292ccc1-e85d-bee7-7c22-55deb28c29dd",
      "0a68a530-8869-248e-cd0b-bda7c81cf677",
      "689c131d-c1b2-4800-7d45-b5ab39aeb74b",
    ];

    return groupCollection.map((collection, index) => (
      <div
        className={`nft-slider-wrapper _${index} w-dyn-list`}
        data-w-id={dataWId[index]}
        key={index}>
        <div role="list" className="sliding-nft-grid w-dyn-items">
          {collection.map((item) => {
            return (
              <div role="listitem" className="w-dyn-item" key={item.id}>
                <NFTImage
                  // src={`https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/${item.id}.png`}
                  src={item.imageURL || getPinataUrl(`${item.id}.png`)}
                  // src={`https://bafybeigfxvhuht4tentzgl2r64ipyadskl3vfc544bci2mejd5zby23ugy.ipfs.infura-ipfs.io/${item.id}.png`}
                  alt={item.name}
                  // onLoad={imageOnLoadHandler}
                  // onError={imageOnErrorHandler}
                />
              </div>
            );
          })}
        </div>
      </div>
    ));
  };

  const renderFeatureGallery = () => {
    return FeaturedImage.map((item) => (
      <div
        className={
          item.id === 1
            ? `featured-nft w-dyn-list`
            : `featured-nft-${item.id} w-dyn-list`
        }
        key={item.id}>
        <div role="list" className="w-dyn-items">
          <div role="listitem" className="w-dyn-item">
            <FeatureImage
              // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc23ab07b40e0cf6c4af6_peep-51.svg"
              src={getPinataUrl(`${item.imageName}.png`)}
              alt={collection.name}
            />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <div className="wrapper">
        <div className="section full-hero wf-section">
          <div className="container w-container">
            <div className="text-box vertical-align">
              {renderFeatureGallery()}
              {/* <div className="featured-nft-5 w-dyn-list">
                <div role="list" className="w-dyn-items">
                  <div role="listitem" className="w-dyn-item">
                    <FeatureImage
                      // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc23ab07b40e0cf6c4af6_peep-51.svg"
                      src="https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/2.png"
                      alt="Avatar 23"
                      className="nft-image"
                    />
                  </div>
                </div>
              </div> */}

              {/* <div className="featured-nft-6 w-dyn-list">
                <div role="list" className="w-dyn-items">
                  <div role="listitem" className="w-dyn-item">
                    <FeatureImage
                      // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc23ab07b40e0cf6c4af6_peep-51.svg"
                      src="https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/1.png"
                      alt="Avatar 23"
                    />
                  </div>
                </div>
              </div>

              <div className="featured-nft-4 w-dyn-list">
                <div role="list" className="w-dyn-items">
                  <div role="listitem" className="collection-item w-dyn-item">
                    <FeatureImage
                      // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc22d2fe0f2872a477016_peep-16.svg"
                      src="https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/3.png"
                      alt="Avatar 8"
                    />
                  </div>
                </div>
              </div>
              <div className="featured-nft-3 w-dyn-list">
                <div role="list" className="w-dyn-items">
                  <div role="listitem" className="w-dyn-item">
                    <FeatureImage
                      // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc23790025a607b02f5ca_peep-44.svg"
                      src="https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/6.png"
                      alt="Avatar 20"
                    />
                  </div>
                </div>
              </div>
              <div className="featured-nft-2 w-dyn-list">
                <div role="list" className="w-dyn-items">
                  <div role="listitem" className="w-dyn-item">
                    <FeatureImage
                      // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc239c4a4254332a96e2a_peep-50.svg"
                      src="https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/10.png"
                      alt="Avatar 22"
                    />
                  </div>
                </div>
              </div>
              <div className="featured-nft w-dyn-list">
                <div role="list" className="w-dyn-items">
                  <div role="listitem" className="w-dyn-item">
                    <FeatureImage
                      // src="https://assets.website-files.com/619f485207368e5749a39a3e/61abc23ab07b40e0cf6c4af6_peep-51.svg"
                      src="https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/15.png"
                      alt="Avatar 23"
                    />
                  </div>
                </div>
              </div> */}

              <img
                src="https://assets.website-files.com/619f485207368e1139a39a1c/61ab33e68d2559a5a47ff5e0_exclusive%20drop.svg"
                loading="lazy"
                width={400}
                alt=""
                className="script-font"
              />
              <h1 className="heading large-h1">Ekibimiz</h1>
              <div className="text-box _550px">
                <p className="paragraph extra-large">
                  <strong>
                    Her biri eşsiz olan çalışanlarımızın dijital eserleri,
                    benzersiz ve gerçekten tekdir =)
                  </strong>
                </p>
              </div>
              <div className="spacer _16" />
              <a
                href={appConfig.openSea}
                className="button w-button"
                target="_blank"
                rel="noreferrer">
                OpenSea'de Görüntüle
              </a>
            </div>
          </div>
        </div>
        <div id="About" className="section blue wf-section">
          <div className="container w-container">
            <div className="_2-grid">
              <div className="text-box _500px">
                <img
                  src="https://assets.website-files.com/619f485207368e1139a39a1c/61ab33e68d2559a5a47ff5e0_exclusive%20drop.svg"
                  loading="lazy"
                  width={284}
                  alt=""
                  className="script-font-4"
                />
                <h2 className="heading h2">
                  Hakkımızda
                  <em />
                </h2>
                <div className="spacer _16" />
                <p className="paragraph">
                  CHAINERIST Yazılım olarak birlikte çalıştığımız tüm
                  arkadaşlarımızın birer fotoğrafını eşsiz sanat eserine
                  dönüştürüp koleksiyon haline getirdik. Bu çalışma bu alandaki
                  çalışma faaliyetlerimizin temsili amaçlıdır, fakat
                  eserlerimize göz atabilir ve satın alabilirsiniz.
                </p>
                <div className="spacer _24" />
                <a
                  href={appConfig.openSea}
                  className="button w-button"
                  target="_blank"
                  rel="noreferrer">
                  Hemen Satın Al
                </a>
              </div>
              <img
                // src="https://assets.website-files.com/619f485207368e1139a39a1c/61abcd829576c14bf9c7889f_iPad%20Pro%2012.svg"
                src={aboutImg}
                loading="lazy"
                width={382}
                id="w-node-_7989f02f-4bee-7713-a7b1-76f4d729a6b7-8da39a1e"
                alt="Avatar Squad NFT Website Template Asset"
                className="center-image mobile-small"
              />
            </div>
          </div>
        </div>
        <div className="section overflow-none wf-section">
          <div className="container center-align w-container">
            {renderGallery()}
            {/* <div
               data-w-id="8292ccc1-e85d-bee7-7c22-55deb28c29dd"
              className="nft-slider-wrapper _1 w-dyn-list"
            >
              <div role="list" className="sliding-nft-grid w-dyn-items">
                {renderGallery()}
              </div>
            </div>
            <div
               data-w-id="0a68a530-8869-248e-cd0b-bda7c81cf677"
              className="nft-slider-wrapper _2 w-dyn-list"
            >
              <div role="list" className="sliding-nft-grid w-dyn-items">
                {renderGallery()}
              </div>
            </div>
            <div
               data-w-id="689c131d-c1b2-4800-7d45-b5ab39aeb74b"
              className="nft-slider-wrapper _3 w-dyn-list"
            >
              <div role="list" className="sliding-nft-grid w-dyn-items">
                {renderGallery()}
              </div>
            </div> */}
          </div>
        </div>
        <div id="Roadmap" className="section light-blue wf-section">
          <div className="container w-container">
            <div className="roadmap-grid">
              <div
                data-w-id="8920d046-73d5-8895-ef13-d8ab48bbc201"
                className="sticky-box">
                <img
                  // src="https://assets.website-files.com/619f485207368e1139a39a1c/61abd1a07cbaae65ddf402e2_iPad%20Pro%2015.svg"
                  src={roadMapImg}
                  loading="lazy"
                  width={382}
                  alt="Avatar Squad NFT Website Template Asset"
                  className="center-image mobile-hidden"
                />
              </div>
              <div className="text-box _500px">
                <div className="spacer _48 hidden-mobile" />
                <img
                  src="https://assets.website-files.com/619f485207368e1139a39a1c/61abd040cf0725c6015821d2_roadmap.svg"
                  loading="lazy"
                  width={202}
                  alt=""
                  className="script-font-3"
                />
                <h2 className="heading h2">
                  YOL HARİTASI
                  <em />
                </h2>
                <p className="paragraph">
                  Uzun zamandır bu işin içerisinde çeşitli sanatçı ve eser
                  sahiplerine teknolojik ve teorik açıdan danışmanlıklar
                  veriyoruz. Sonunda kendimize de bir eser yarattık ve bir plana
                  bağladık.
                </p>
                <div className="spacer _16" />
                <div className="roadmap-block">
                  <h3 className="heading h4">
                    <ColorNumber>1.</ColorNumber>İlk Satış
                    <em />
                  </h3>
                  <p className="paragraph medium">
                    İlk eserimiz satıldığında ofiste parti yapacağız, satın alan
                    kişinin de katılması için özel davetiye göndereceğiz.
                  </p>
                </div>
                <div className="roadmap-block">
                  <h3 className="heading h4">
                    <ColorNumber>2.</ColorNumber>
                    Sosyalleşme ve Hediye
                    <em />
                  </h3>
                  <p className="paragraph medium">
                    Eserlerimizin %40’ı satın alındığında bir Discord toplantısı
                    yapacağız ve satın alanlardan 1 kişinin de eserini NFT
                    olarak üretip koleksiyonlarımıza dahil edeceğiz.
                  </p>
                </div>
                <div className="roadmap-block">
                  <h3 className="heading h4">
                    <ColorNumber>3.</ColorNumber>
                    Haytap
                    <em />
                  </h3>
                  <p className="paragraph medium">
                    Eserlerimizin %50’si satın alındığında HAYTAP Derneğine mama
                    bağışı yapmayı hedefliyoruz.
                  </p>
                </div>
                <div className="roadmap-block">
                  <h3 className="heading h4">
                    <ColorNumber>4.</ColorNumber>
                    Darüşşafaka
                    <em />
                  </h3>
                  <p className="paragraph medium">
                    Eserlerimizin %70’i satın alındığında DARÜŞAFAKA Derneğine
                    çocuklarımızın, kardeşlerimizin eğitimi için destekte
                    bulunacağız.
                  </p>
                </div>
                <div className="roadmap-block">
                  <h3 className="heading h4">
                    <ColorNumber>5.</ColorNumber>
                    Yeni Eser Oluşturma
                    <em />
                  </h3>
                  <p className="paragraph medium">
                    Eserlerimizin %90’ı satın alındığında yeni eserler
                    üreteceğiz.
                  </p>
                </div>
                <div className="roadmap-block">
                  <h3 className="heading h4">
                    <ColorNumber>6.</ColorNumber>
                    CHAINERIST Team's NFT Bursu
                    <em />
                  </h3>
                  <p className="paragraph medium">
                    Eserlerimizin tamamı satın alındığında 10 İlköğretim
                    öğrencisine, 1 üniversite öğrencisine öğrenim bursu
                    vereceğiz.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Attributes" className="section large wf-section">
          <div className="container w-container">
            <div className="rarity-grid">
              <div className="text-box _500px mobile-center">
                <img
                  src="https://assets.website-files.com/619f485207368e1139a39a1c/61abd8ceaf5a8b43117fb9c1_rarity.svg"
                  loading="lazy"
                  width={130}
                  alt=""
                  className="script-font-4"
                />
                <h2 className="heading h2">BENZERSİZLİK</h2>
                <p className="paragraph">
                  Her biri bir T.C. vatandaşı ve bir ID değerleri var, benzersiz
                  derken gerçekten benzersiz kişilerin birer fotoğrafını dijital
                  bir eser haline getirdik. Şaka bir yana CHAINERIST olarak
                  bizim biz olmamızda katkı sağlayan tüm ekip üyelerimizin birer
                  fotoğrafını filtrelerden geçirerek NFT'lerini oluşturduk.
                  Bunları da size açtık.
                </p>
                <div className="spacer _16" />
                {/* <div className="w-layout-grid rarity-block back-lime">
                  <div>
                    <strong>Common</strong>
                  </div>
                  <div>Folk</div>
                </div>
                <div className="w-layout-grid rarity-block faint-lime">
                  <div>
                    <strong>Uncommon</strong>
                  </div>
                  <div>Dudes</div>
                </div>
                <div className="w-layout-grid rarity-block soft-lime">
                  <div>
                    <strong>Rare</strong>
                  </div>
                  <div>Gang</div>
                </div>
                <div className="w-layout-grid rarity-block lime">
                  <div>
                    <strong>Ultra</strong>
                  </div>
                  <div>Team</div>
                </div>
                <div className="w-layout-grid rarity-block dark-lime">
                  <div>
                    <strong>Legendary</strong>
                  </div>
                  <div>Squad</div>
                </div> */}
              </div>
              <img
                // src="https://assets.website-files.com/619f485207368e1139a39a1c/61abdf2e90025a82c20391bb_Swap%20Faces.svg"
                src={rarityImg}
                loading="lazy"
                // width={644}
                width={500}
                id="w-node-be77ec89-8fc5-5e83-bcf8-c7a54b5b8683-8da39a1e"
                alt="Rarity NFT Website Template Asset"
                className="center-image"
              />
            </div>
          </div>
        </div>
        <div id="Creator" className="section blue wf-section">
          <div className="container w-container">
            <div className="creator-grid">
              <img
                // src="https://assets.website-files.com/619f485207368e1139a39a1c/61abde235f1942a1a3fd180b_Group%2010.svg"
                src={creatorImg}
                loading="lazy"
                width={460}
                alt="Avatar Squad NFT Website Template Asset"
                className="center-image mobile-small"
              />
              <div className="text-box _500px">
                <img
                  src="https://assets.website-files.com/619f485207368e1139a39a1c/61abdb7fd096cf41eae25ae9_creator.svg"
                  loading="lazy"
                  width={161}
                  alt=""
                  className="script-font-4"
                />
                <h2 className="heading h2">Yaratılış Hikayesi</h2>
                <div className="spacer _16" />
                <p className="paragraph large">
                  CHAINERIST Yazılım Proje Geliştirme Departmanı, olarak bu
                  fikri geliştirdik. Eserlerin oluşumunda yani fotoğrafların
                  filtrelenmesinde bazı free uygulamalar kullandık ama sonuçta
                  bunu da profesyonelce yapabiliriz. Sadece tesadüf eseri
                  bulduğumuz bir filtre çok hoşumuza gittiği için bu şekilde
                  ilerledik.
                </p>
                <div className="spacer _24" />
                {/* <a
                  href="http://www.twitter.com"
                  target="_blank"
                  className="button w-button"
                  rel="noreferrer"
                >
                  Follow on Twitter
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div id="Attributes" className="section large wf-section">
          <div className="container w-container">
            <div id="Account" className="questions-section">
              <div className="text-box center-align">
                <h2 className="heading h2">Sıkça Sorulan Sorular</h2>
                <div className="spacer _24" />
              </div>
              <div className="questions">
                <div
                  href="#"
                  data-ix="show-answer"
                  data-w-id="b41b8676-f6cb-e282-a182-a81245d07c13"
                  className="question-container">
                  <div className="question">
                    <div className="heading h4">
                      Neden bu şekilde bir çalışma yaptınız ?
                    </div>
                    <img
                      src="https://assets.website-files.com/619f485207368e1139a39a1c/61abf87090025a1fac0468d1_Light%20Blue%20Dropdown.svg"
                      alt=""
                      className="question-arrow-icon"
                    />
                  </div>
                  <div
                    data-ix="hide-on-load"
                    style={{ display: "none", height: "0PX" }}
                    className="answer">
                    <p>
                      Çeşitli sanatları icra eden kişilerin NFT'ye olan
                      ilgilerine cevap verebilmek için sürekli bir sunum
                      hazırlığımız vardı. Bunu ortadan kaldırabilmek adına biz
                      de bu şekilde bir proje fikri geliştirdik. Severek,
                      isteyerek yaptık, çok da güzel olduğunu düşünüyoruz.
                    </p>
                  </div>
                </div>
                <div
                  href="#"
                  data-ix="show-answer"
                  data-w-id="b41b8676-f6cb-e282-a182-a81245d07c1b"
                  className="question-container">
                  <div className="question">
                    <div className="heading h4">
                      NFT'leri nerede yayınladınız ?
                    </div>
                    <img
                      src="https://assets.website-files.com/619f485207368e1139a39a1c/61abf87090025a1fac0468d1_Light%20Blue%20Dropdown.svg"
                      alt=""
                      className="question-arrow-icon"
                    />
                  </div>
                  <div
                    data-ix="hide-on-load"
                    style={{ display: "none", height: "0PX" }}
                    className="answer">
                    <p>OpenSea</p>
                  </div>
                </div>
                <div
                  href="#"
                  data-ix="show-answer"
                  data-w-id="b41b8676-f6cb-e282-a182-a81245d07c23"
                  className="question-container">
                  <div className="question">
                    <div className="heading h4">
                      Buradaki arkadaşlar kimler ? Ünlü mü ?
                    </div>
                    <img
                      src="https://assets.website-files.com/619f485207368e1139a39a1c/61abf87090025a1fac0468d1_Light%20Blue%20Dropdown.svg"
                      alt=""
                      className="question-arrow-icon"
                    />
                  </div>
                  <div
                    data-ix="hide-on-load"
                    style={{ display: "none", height: "0PX" }}
                    className="answer">
                    <p>
                      Onlar bizim için ünlü ama sizin için olmayabilir, bizim
                      biz olmamızı sağlayan çalışma arkadaşlarımızdır. Onları
                      tanımak için Galeri sayfasındaki kişi kartlarına
                      tıklayabilirsiniz.
                    </p>
                  </div>
                </div>
                <div
                  href="#"
                  data-ix="show-answer"
                  data-w-id="b41b8676-f6cb-e282-a182-a81245d07c2b"
                  className="question-container">
                  <div className="question">
                    <div className="heading h4">
                      NFT'lerinizi satın alabilir miyim ?
                    </div>
                    <img
                      src="https://assets.website-files.com/619f485207368e1139a39a1c/61abf87090025a1fac0468d1_Light%20Blue%20Dropdown.svg"
                      alt=""
                      className="question-arrow-icon"
                    />
                  </div>
                  <div
                    data-ix="hide-on-load"
                    style={{ display: "none", height: "0PX" }}
                    className="answer">
                    <p>Evet tabiki, bunun için bir road map bile hazırladık.</p>
                  </div>
                </div>
                <div
                  href="#"
                  data-ix="show-answer"
                  data-w-id="b41b8676-f6cb-e282-a182-a81245d07c2b"
                  className="question-container">
                  <div className="question">
                    <div className="heading h4">
                      NFT'sini aldığımız arkadaş bize çalışacak mı ?
                    </div>
                    <img
                      src="https://assets.website-files.com/619f485207368e1139a39a1c/61abf87090025a1fac0468d1_Light%20Blue%20Dropdown.svg"
                      alt=""
                      className="question-arrow-icon"
                    />
                  </div>
                  <div
                    data-ix="hide-on-load"
                    style={{ display: "none", height: "0PX" }}
                    className="answer">
                    <p>Kaşlarımızı çattık sana bakıyoruz</p>
                  </div>
                </div>
                <div
                  href="#"
                  data-ix="show-answer"
                  data-w-id="b41b8676-f6cb-e282-a182-a81245d07c2b"
                  className="question-container">
                  <div className="question">
                    <div className="heading h4">
                      Benimde sanat eserlerim var ve NFT konusunda fikir almak
                      istiyorum, size nasıl ulaşabilirim ?
                    </div>
                    <img
                      src="https://assets.website-files.com/619f485207368e1139a39a1c/61abf87090025a1fac0468d1_Light%20Blue%20Dropdown.svg"
                      alt=""
                      className="question-arrow-icon"
                    />
                  </div>
                  <div
                    data-ix="hide-on-load"
                    style={{ display: "none", height: "0PX" }}
                    className="answer">
                    <p>
                      İletişim sayfasından ya da nft@chainerist.com adresinden
                      bize mail atarak ulaşabilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section lime overflow-none wf-section">
          <div className="container w-container">
            <div className="w-layout-grid _2-grid">
              <div className="text-box">
                <div className="text-box _500px">
                  <h2 className="heading h2">
                    Hemen birini satın alabilir ya da tüm koleksiyonumuzu
                    inceleyebilirsiniz.
                  </h2>
                  <p className="paragraph">
                    Link sizi NFT MarkaetPlace'de yer alan koleksiyonlarımıza
                    yönlendirecektir, burada dilediğinizi satın alabilir ya da
                    inceleyebilirsiniz. Personellerimizin kimler olduğuna ve
                    künyelerine bakmak için Galeri sayfamızı ziyaret
                    edebilirsiniz.
                  </p>
                  <div className="spacer _16" />
                  <a
                    href={appConfig.openSea}
                    className="button blue w-button"
                    target="_blank"
                    rel="noreferrer">
                    OpenSea'de Görüntüle
                  </a>
                </div>
              </div>
              <img
                // src="https://assets.website-files.com/619f485207368e1139a39a1c/61abcd829576c14bf9c7889f_iPad%20Pro%2012.svg"
                src={yellowSectionImg}
                loading="lazy"
                width={360}
                alt="Avatar Squad NFT Website Template Asset"
                className="overflow-image-right mobile-hidden"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
